export const dealInfoTabSelector = (state) => state.dealInfoTab.dealInfoData;
export const dealInfoTabLoadingSelector = (state) =>
  state.dealInfoTab.isLoadingDealInfo;
